"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseQueryParams", {
    enumerable: true,
    get: function() {
        return BaseQueryParams;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const BaseQueryParams = _zod.z.object({
    limit: _zod.z.preprocess((val)=>Number.parseInt(val, 10), _zod.z.number().min(5).max(200, {
        message: "Limit must be between 5 and 200"
    })).optional().default(20),
    skip: _zod.z.preprocess((val)=>Number.parseInt(val, 10), _zod.z.number().min(0)).optional().default(0),
    sort: _utilsisomorphic.sortStringSchema.optional()
});
